






























// Importing components
import BaseButton from '@/ui/BaseButton.vue';
import BaseCard from '@/ui/BaseCard.vue';
import BaseInputField from '@/ui/BaseInputField.vue';
import BasePagination from '@/base/BasePagination.vue';
import LayoutApp from '@/layputs/LayoutApp.vue';
import TheTableOrders from '@/components/orders/TheTableOrders.vue';
// Importing function
import {getOrders} from '@/ts/orders/get-orders';

export default {
    name: 'PageOrders',
    components: {
        BaseButton,
        BaseCard,
        BaseInputField,
        BasePagination,
        LayoutApp,
        TheTableOrders,
    },
    props: {},
    data() {
        return {};
    },
    methods: {
        // Switching between pages
        switchPage(page) {
            this.$store.dispatch('setLoadingOn');
            this.$store.dispatch('setCurrentPage', page);
            getOrders().finally(() => {
                this.$store.dispatch('setLoadingOff');
            });
        },
    },
    created() {
        this.$store.dispatch('setQueryParam', '');
        this.$store.dispatch('setOrderParam', '');
        this.$store.dispatch('setSortParam', '');
        this.$store.dispatch('setCurrentPage', 1);
        // Fetching data from the API
        getOrders().finally(() => {
            this.$store.dispatch('setLoadingOff');
        });
    },
};
